import 'components/usingMouse';

$('body').on('mousemove', () => {
    /* collapse all the dropdown menus */
    const item = $('ul.header__subnav');
    if (item.hasClass('filter-focus')) {
        item.removeClass('filter-focus');
    }
});

/**
 * Sean Holt <sean.holt@cbsinteractive.com> (for reference purposes, if you need to contact me about this)
 * Simple on-page-loaded function to traverse for the div/a/button's on each page so that if we ever need to change
 * specific attributes we only have to do it in one place (for accessibility reasons)!
 *
 * SASS for focusable:focus (outlines, etc)
 * web-package-coreui/src/styles/components/_accessibility.scss
 *
 */
export function UpdateFocusable() {
    const items = document.querySelectorAll('.focusable');

    items.forEach((elem, index) => {
        const attribs = elem.getAttributeNames();
        // Img alt's copied into aria-label's
        if (attribs.indexOf('aria-label') === -1 && attribs.indexOf('label') !== -1) {
            elem.setAttribute('aria-label', elem.getAttribute('label'));
        }
        if (
            elem.tagName === 'img' &&
            attribs.indexOf('alt') !== -1 &&
            attribs.indexOf('aria-label') === -1
        ) {
            elem.setAttribute('aria-label', elem.getAttribute('alt'));
            // Fall-back just in case label is set but aria-label is not.
            if (attribs.indexOf('label') !== -1 && attribs.indexOf('aria-label') === -1) {
                elem.setAttribute('aria-label', elem.getAttribute('label'));
            }
        }
        // Do we want to override !button roles or just ignore if a role is set?
        if (attribs.indexOf('role') === -1) {
            // Javascript handled link, we set to button by default. If you need to override this, set the role to 'link' in the element.
            if (attribs.indexOf('href') && elem.getAttribute('href') === '#') {
                elem.setAttribute('role', 'button');
            } else {
                elem.setAttribute('role', 'link');
            }
        }
        if (attribs.indexOf('tabindex') === -1) {
            elem.setAttribute('tabindex', '0');
        }
    });
}
